/* Callisto: variantvælgeren (fx ringstørrelse) åbner som en liste i sidens eget design i stedet for telefonens grå systemvindue.
   Den rigtige <select> bliver liggende og styrer stadig valget – listen sætter bare dens værdi, så kurv, pris og lager virker som før. */
(function () {
  if (window.ClVariantDd) return;
  var aaben = null;

  function luk() {
    if (!aaben) return;
    aaben.wrap.classList.remove('cl-dd--open');
    aaben.list.hidden = true;
    aaben.hit.setAttribute('aria-expanded', 'false');
    aaben = null;
  }

  function enhance(wrap) {
    if (wrap.hasAttribute('data-cl-dd')) return;
    var select = wrap.querySelector('select');
    if (!select) return;
    wrap.setAttribute('data-cl-dd', '');
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');

    var label = '';
    var lab = select.id && document.querySelector('label[for="' + select.id + '"]');
    if (lab) label = lab.textContent.replace(/\s+/g, ' ').trim();

    var hit = document.createElement('button');
    hit.type = 'button';
    hit.className = 'cl-dd__hit';
    hit.setAttribute('aria-haspopup', 'listbox');
    hit.setAttribute('aria-expanded', 'false');
    hit.setAttribute('aria-label', label || 'Välj');

    var list = document.createElement('ul');
    list.className = 'cl-dd__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    wrap.appendChild(hit);
    wrap.appendChild(list);

    var self = { wrap: wrap, list: list, hit: hit };

    function byg() {
      list.innerHTML = '';
      [].forEach.call(select.options, function (o) {
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.className = 'cl-dd__opt';
        li.textContent = o.textContent.trim();
        li.setAttribute('data-value', o.value);
        if (o.value === select.value) { li.classList.add('is-selected'); li.setAttribute('aria-selected', 'true'); }
        if (o.disabled) { li.classList.add('is-disabled'); li.setAttribute('aria-disabled', 'true'); }
        else li.tabIndex = 0;
        list.appendChild(li);
      });
    }

    function vaelg(v) {
      if (v !== select.value) {
        select.value = v;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      luk();
      hit.focus();
    }

    hit.addEventListener('click', function (e) {
      e.preventDefault();
      if (aaben === self) { luk(); return; }
      luk();
      byg();
      list.hidden = false;
      wrap.classList.add('cl-dd--open');
      hit.setAttribute('aria-expanded', 'true');
      aaben = self;
    });

    list.addEventListener('click', function (e) {
      var li = e.target.closest('.cl-dd__opt');
      if (!li || li.classList.contains('is-disabled')) return;
      vaelg(li.getAttribute('data-value'));
    });

    list.addEventListener('keydown', function (e) {
      var li = e.target.closest('.cl-dd__opt');
      if (!li) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (!li.classList.contains('is-disabled')) vaelg(li.getAttribute('data-value')); }
      else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var alle = [].slice.call(list.querySelectorAll('.cl-dd__opt:not(.is-disabled)'));
        var i = alle.indexOf(li) + (e.key === 'ArrowDown' ? 1 : -1);
        if (alle[i]) alle[i].focus();
      }
    });
  }

  document.addEventListener('click', function (e) {
    if (aaben && !aaben.wrap.contains(e.target)) luk();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && aaben) { var h = aaben.hit; luk(); h.focus(); }
  });

  function koer() {
    [].forEach.call(document.querySelectorAll('.product__variants-wrapper .select-wrapper'), enhance);
  }
  var venter = null;
  function start() {
    koer();
    new MutationObserver(function () { clearTimeout(venter); venter = setTimeout(koer, 80); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  window.ClVariantDd = { koer: koer };
})();
